<template>
  <div class="header-nav">
    <div class="header-nav-center">
      <div class="header-nav-left" @click="goDes" style="cursor: pointer;">
        <img src="https://tianzestd.oss-cn-beijing.aliyuncs.com/image/20250402012828.png" alt="logo">
      </div>
      <div class="header-nav-center-tabs">
        <div class="header-nav-center-tabs-item" :class="{ active: route.path.indexOf(activeTab) !== -1 }"
          v-for="route in tabRoutes" :key="route.path" @click="handleTabClick(route)">
          <span>{{ route.title }}</span>
        </div>
      </div>
      <div class="header-nav-right">
        <!-- <div class="phone-number">
          <span>4008-008-820</span>
        </div> -->
        <div class="header-nav-right-login" @click="openLogin('dl')" v-if="!isLogin">
          <span>登录</span>
        </div>
        <div class="header-info" v-if="isLogin">
          <div class="header-info-name">
            {{ userName }}
          </div>
          <el-dropdown @command="handleCommand">
            <div class="header-info-img">
              <img :src="avatar || require('@/assets/home/headerImg.png')" alt="">
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="personalCenter">个人中心</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <!-- 聊天消息 -->
    <div class="chat-message" @click="openChatMessagePopup" v-if="isLogin&&orderCount>0">
      <div class="chat-message-num" v-if="noreadCount > 0">{{ noreadCount }}</div>
    </div>

    <!-- 弹出层 -->
    <div class="dark-bg" v-if="isShowLogin && handleLoginType == 'dl'">
      <div class="login-container">
        <div class="close-login" @click="closeLogin"></div>
        <div class="tab-login">
          <div class="tab-login-item" v-for="item in tabList" :key="item.type"
            :class="{ active: currentTab === item.type }" @click="handleTabLogin(item)">
            <span>{{ item.title }}</span>
          </div>
        </div>
        <div class="login-content">
          <div class="login-content-item">
            <div class="login-content-item-title">
              <span>手机号</span>
            </div>
            <div class="login-content-item-input">
              <input type="text" placeholder="请输入手机号" v-model="phone">
            </div>
          </div>

          <div class="login-content-item" style="margin-top: 33px;">
            <div class="login-content-item-title">
              <span>验证码</span>
            </div>
            <div class="login-content-item-input">
              <input type="text" v-model="code" placeholder="请输入验证码">
              <div class="login-content-item-input-code" :class="{ 'disabled': countdown > 0 }" @click="handleGetCode">
                <span>{{ countdownText }}</span>
              </div>
            </div>
          </div>

          <div class="login-content-item-read">
            <el-checkbox size="small" v-model="checked"></el-checkbox>
            <span style="font-size: 14px;color: #666666;margin-left: 10px;">已阅读并同意</span>
            <span style="font-size: 14px;color: #F45A27;margin-left: 10px;cursor: pointer;"
              @click="openAgreement('user')">《用户协议》</span>
            <span style="font-size: 14px;color: #F45A27;margin-left: 10px;cursor: pointer;"
              @click="openAgreement('privacy')">《隐私政策》</span>
          </div>

          <div class="login-content-item-button" @click="handleLogin">
            登录
          </div>
        </div>

        <div class="login-content-item-button-box">
          Copyright @2024 牛法顾科技(上海)有限公司 备案号:沪备20240911212512
        </div>
      </div>
    </div>
    <div class="dark-bg" v-if="isShowLogin && handleLoginType == 'buyForLogin'">
      <div class="login-container">
        <div class="close-login" @click="closeLogin"></div>
        <div class="tab-login" style="height: 60px;font-size: 20px;font-weight: 600;color: #333333;text-align: center;">
          <!-- <div class="tab-login-item" v-for="item in tabList" :key="item.type"
            :class="{ active: currentTab === item.type }" @click="handleTabLogin(item)">
            <span>{{ item.title }}</span>
          </div> -->
          用户登录
        </div>
        <div class="login-content">
          <div class="login-content-item">
            <div class="login-content-item-title">
              <span>手机号</span>
            </div>
            <div class="login-content-item-input">
              <input type="text" placeholder="请输入手机号" v-model="phone">
            </div>
          </div>

          <div class="login-content-item" style="margin-top: 33px;">
            <div class="login-content-item-title">
              <span>验证码</span>
            </div>
            <div class="login-content-item-input">
              <input type="text" v-model="code" placeholder="请输入验证码">
              <div class="login-content-item-input-code" :class="{ 'disabled': countdown > 0 }" @click="handleGetCode">
                <span>{{ countdownText }}</span>
              </div>
            </div>
          </div>

          <div class="login-content-item-read">
            <el-checkbox size="small" v-model="checked"></el-checkbox>
            <span style="font-size: 14px;color: #666666;margin-left: 10px;">已阅读并同意</span>
            <span style="font-size: 14px;color: #F45A27;margin-left: 10px;cursor: pointer;"
              @click="openAgreement('user')">《用户协议》</span>
            <span style="font-size: 14px;color: #F45A27;margin-left: 10px;cursor: pointer;"
              @click="openAgreement('privacy')">《隐私政策》</span>
          </div>

          <div class="login-content-item-button" @click="handleLogin">
            登录
          </div>
        </div>

        <div class="login-content-item-button-box">
          Copyright @2024 牛法顾科技(上海)有限公司 备案号:沪备20240911212512
        </div>
      </div>
    </div>


    <!-- 聊天弹出层 -->
    <div class="chat-message-popup-mask" v-if="isShowChatMessagePopup">
      <div class="chat-message-popup">
        <div class="chat-mask-content-cha" @click="closeChatMessagePopup"></div>
        <div class="home-main">
          <div class="home-TUIKit">
            <div class="home-TUIKit-main">
              <div class="home-TUIKit-main">
                <div class="home-conversation">
                  <TUIConversation />
                </div>
                <div class="home-chat">
                  <TUIChat></TUIChat>
                </div>
                <TUIContact display-type="selectFriend" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TUIChat, TUIConversation, TUIContact, TUIGroup, TUISearch } from '../TUIKit';
import { mapState, mapGetters, mapActions } from 'vuex'
import { TUILogin } from '@tencentcloud/tui-core';
import TencentCloudChat from '@tencentcloud/chat';
import { framework } from '../TUIKit/adapter-vue';

export default {
  name: 'TabNavigation',
  components: {
    TUIChat,
    TUIConversation,
    TUIContact,
    TUIGroup,
    TUISearch
  },
  data() {
    return {
      activeTab: this.$route.path,
      isShowChatMessagePopup: false,
      tabRoutes: [
        { path: '/home', title: '首页' },
        { path: '/packageIntroduction', title: '企业法律顾问' },
        { path: '/packagePrivate', title: '私人法律顾问' },
        { path: '/packageDetailsForDz', title: '专项服务' },
        { path: '/legalinstrument', title: '文书模板下载' },
        { path: '/legalknowledge', title: '法律知识' },
        // { path: '/videoCourses', title: '视频课程' }
      ],
      isShowLogin: false,
      tabList: [
        {
          title: '用户登录',
          type: 'user'
        },
        {
          title: '律师登录',
          type: 'ls'
        }
      ],
      currentTab: 'user',
      countdown: 0,
      timer: null,
      phone: '',
      code: '',
      checked: false,
      chat: null,
      sdkReady: false,
      noreadCount: 0,
      handleLoginType: 'dl',
      orderCount:0
    }
  },
  computed: {
    ...mapGetters('user', [
      'isLogin',
      'userName',
      'avatar',
      'roles',
      'timId'
    ]),
    countdownText() {
      if (this.countdown > 0) {
        return `${this.countdown}秒后重试`
      }
      return '获取验证码'
    }
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('showLoginDialog');
  },
  created() {
    // 初始化时设置正确的活动标签
    this.activeTab = this.$route.path
  },
  mounted() {
    if (this.isLogin) {
      this.initChat();
      this.getOrderList()
    }
    window.addEventListener('showLoginDialog', () => {
      this.openLogin();
    });
  },
  watch: {
    $route(to) {
      this.activeTab = to.path
    }
  },
  methods: {
    async getOrderList() {
      try {
        const res = await this.$api.user.getMyOrder()
        if (res.code == 200) {
          this.orderCount = res.data.length
        }
      } catch (error) {
        this.$http.handleError(error)
      }
    },
    ...mapActions('user', [
      'login',
      'getUserInfo',
      'updateUserInfo',
      'logout'
    ]),

    goDes() {
      this.$router.push({
        path: '/agreement',
        query: { id: 14, temp: new Date().getTime() }
      })
    },
    openChatMessagePopup() {
      this.isShowChatMessagePopup = true;
    },
    closeChatMessagePopup() {
      this.isShowChatMessagePopup = false;
    },
    openAgreement(type) {
      if (this.currentTab == 'user') {
        if (type == 'user') {
          this.$router.push({
            path: '/agreement',
            query: { id: 15, temp: new Date().getTime() }
          })
        } else {
          this.$router.push({
            path: '/agreement',
            query: { id: 16, temp: new Date().getTime() }
          })
        }
      } else {
        if (type == 'user') {
          this.$router.push({
            path: '/agreement',
            query: { id: 17, temp: new Date().getTime() }
          })
        } else {
          this.$router.push({
            path: '/agreement',
            query: { id: 18, temp: new Date().getTime() }
          })
        }
      }
      // location.reload()
      this.isShowLogin = false
    },

    handleCommand(command) {
      if (command == 'personalCenter') {
        if (this.roles == 'ls') {
          this.$router.push({
            path: '/stage/user'
          })
        } else {
          this.$router.push({
            path: '/stage/userForClient'
          })
        }
      }
      if (command == 'logout') {
        this.logout();
        if (this.$route.path.indexOf('/stage') !== -1) {
          this.$router.push({
            path: '/home'
          })
        } else {
          this.$router.go(0)
        }
      }
    },
    // 获取验证码
    async getPhoneCode() {
      try {
        let res = await this.$api.user.getPhoneCode({ phone: this.phone })
        if (res.code == 200) {
          this.$toast.success('验证码发送成功' + res.data);
        }
      } catch (error) {
        this.$http.handleError(error)
      }
    },

    handleTabLogin(item) {
      this.currentTab = item.type
    },
    openLogin(type = 'buyForLogin') {
      this.currentTab = 'user'
      this.isShowLogin = true;
      this.handleLoginType = type
    },
    closeLogin() {
      this.isShowLogin = false;
    },
    async handleLogin() {
      if (!this.phone) {
        this.$toast.error('请输入手机号')
        return
      }
      // 校验手机号
      if (!this.phone.match(/^1[3-9]\d{9}$/)) {
        this.$toast.error('请输入正确的手机号')
        return
      }

      if (!this.code) {
        this.$toast.error('请输入验证码')
        return
      }
      if (!this.checked) {
        this.$toast.error('请阅读并同意用户协议和隐私协议')
        return
      }

      try {
        await this.login({ phone: this.phone, code: this.code, type: this.currentTab })
        let userInfoRes = await this.getUserInfo();
        if (userInfoRes.code == 200) {
          await this.initChat();
          this.closeLogin();
          // 刷新页面
          this.$router.go(0);
        }
      } catch (error) {
        console.error('登录失败:', error);
      }
    },
    handleTabClick(tab) {
      if (this.$route.path !== tab.path) {
        this.$router.push(tab.path)
      }
    },
    async handleGetCode() {
      if (!this.phone) {
        this.$toast.error('请输入手机号')
        return
      }
      // 校验手机号
      if (!this.phone.match(/^1[3-9]\d{9}$/)) {
        this.$toast.error('请输入正确的手机号')
        return
      }
      // 如果正在倒计时，不允许点击
      if (this.countdown > 0) return
      // 开始倒计时
      this.countdown = 60
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.timer)
        }
      }, 1000)

      // 这里添加发送验证码的逻辑
      this.getPhoneCode()
    },
    // 初始化聊天
    async initChat() {
      try {
        // 获取用户信息
        const userInfoRes = await this.getUserInfo();
        if (userInfoRes.code === 200) {

          // 创建聊天实例
          this.chat = TencentCloudChat.create({
            SDKAppID: 1600071710
          });

          // 登录聊天
          const loginResult = await TUILogin.login({
            SDKAppID: this.timId,
            userID: userInfoRes.data.phone,
            userSig: userInfoRes.data.userSig,
            useUploadPlugin: true,
            framework,
          });
          console.log('聊天登录成功:', loginResult);

          // 检查SDK状态
          if (this.chat.isReady()) {
            console.log('SDK已经就绪');
            this.sdkReady = true;
            this.initMessageListeners();
          } else {
            console.log('等待SDK就绪...');
            // 设置一个超时检查
            const checkReady = setInterval(() => {
              if (this.chat.isReady()) {
                console.log('SDK就绪');
                this.sdkReady = true;
                this.initMessageListeners();
                clearInterval(checkReady);
              }
            }, 1000);

            // 设置超时时间
            setTimeout(() => {
              if (!this.sdkReady) {
                console.error('SDK就绪超时');
                clearInterval(checkReady);
              }
            }, 10000);
          }
        }
      } catch (error) {
        console.error('聊天初始化失败:', error);
      }
    },

    // 初始化消息监听
    initMessageListeners() {
      if (!this.chat) {
        console.log('聊天实例不存在，无法初始化消息监听');
        return;
      }

      console.log('开始初始化消息监听...');

      // 监听新消息
      this.chat.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, (event) => {
        console.log('收到新消息:', event);
        this.updateUnreadCount();
      });

      // 监听会话列表更新
      this.chat.on(TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED, (event) => {
        console.log('会话列表更新:', event);
        this.updateUnreadCount();
      });

      // 主动获取一次未读消息数
      this.updateUnreadCount();
    },

    // 更新未读消息数
    updateUnreadCount() {
      // console.log('更新未读消息数, SDK状态:', this.sdkReady, '聊天实例:', this.chat);
      if (this.sdkReady && this.chat) {
        try {
          const count = this.chat.getTotalUnreadMessageCount();
          this.noreadCount = count;
        } catch (error) {
          // console.error('获取未读消息数失败:', error);
        }
      } else {
        console.log('SDK未就绪或聊天实例不存在，无法获取未读消息数');
      }
    }
  },
  beforeDestroy() {
    // 组件销毁时清除定时器和事件监听
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.chat) {
      this.chat.off(TencentCloudChat.EVENT.SDK_READY);
      this.chat.off(TencentCloudChat.EVENT.MESSAGE_RECEIVED);
      this.chat.off(TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED);
    }
  }
}
</script>

<style scoped lang="scss">
.chat-message-popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;

  .chat-message-popup {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1000px;
    height: 700px;
    .chat-mask-content-cha {
      z-index: 14;
      cursor: pointer;
      position: absolute;
      top: 64px;
      right: 74px;
      width: 14px;
      height: 14px;
      background: url('@/assets/home/cha.png') no-repeat center center;
      background-size: 100% 100%;
    }
    .home-main {
      box-sizing: border-box;
      flex: 1;
      display: flex;
      justify-content: center;
      overflow: hidden;
      padding: 50px;
      width: 100%;
      height: 100%;
      .home-TUIKit {
        box-sizing: border-box;
        display: flex;
        flex: 1;
        width: 100%;
        height: 100%;
        max-width: 1400px;
        overflow: hidden;
        min-height: 640px;
        border-radius: 12px;
        background-color: #ffffff;
        box-shadow: 0 11px 20px 0 rgba(0, 0, 0, 0.3);
        .home-TUIKit-navbar {
          box-sizing: border-box;
          display: flex;
        }
        .home-TUIKit-main {
          box-sizing: border-box;
          flex: 1;
          display: flex;
          overflow: hidden;
          flex-direction: row;
          border: 0 solid black;
          .home-conversation,
          .home-relation {
            min-width: 285px;
            box-sizing: border-box;
            flex: 0 0 24%;
            display: flex;
            flex-direction: column;
            border-right: 1px solid #f4f5f9;
          }
          .home-chat {
            box-sizing: border-box;
            min-width: 0;
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            position: relative;
          }
        }
        .callkit-drag-container {
          position: fixed;
          z-index: 100;
          background-color: #ffffff;
          user-select: none;
          &-pc {
            left: calc(50% - 25rem);
            top: calc(50% - 18rem);
            width: 50rem;
            height: 36rem;
            border-radius: 16px;
            box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
          }
          &-mini {
            width: 168px;
            height: 56px;
            right: 10px;
            top: 70px;
            background-color: transparent;
            border-radius: 0px;
            box-shadow: none;
          }
        }
      }
    }
  }
}

.chat-message {
  position: fixed;
  bottom: 200px;
  right: 26px;
  width: 72px;
  height: 72px;
  background: url(../assets/home/qwe.png) no-repeat center center;
  background-size: 100% 100%;
  z-index: 100;
  cursor: pointer;

  .chat-message-num {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    background: #F45A27;
    border-radius: 50%;
    color: #ffffff;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    line-height: 16px;
  }
}

.dark-bg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;

  .login-container {
    width: 540px;
    height: 518px;
    background-color: #ffffff;
    border-radius: 8px 8px 8px 8px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -259px;
    margin-left: -270px;

    .close-login {
      cursor: pointer;
      width: 20px;
      height: 20px;
      background: url("../assets/home/cha.png") no-repeat center center;
      position: absolute;
      top: 10px;
      right: 10px;
    }

    .tab-login {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 90px;
      border-bottom: 1px solid rgba(237, 238, 239, 1);

      .tab-login-item {
        cursor: pointer;
        width: 210px;
        height: 46px;
        border-radius: 3px;
        background: #E8EBED;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #595959;
        text-align: center;
        line-height: 46px;

        &.active {
          background: rgba(244, 90, 39, 1);
          color: #ffffff;
        }
      }
    }

    .login-content {
      width: 100%;
      height: 377px;
      border-bottom: 1px solid rgba(237, 238, 239, 1);
      padding: 27px 59px;

      .login-content-item {
        width: 100%;

        .login-content-item-title {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #333333;
        }

        .login-content-item-input {
          margin-top: 16px;
          width: 100%;
          height: 46px;
          background: #FFFFFF;
          border-radius: 3px 3px 3px 3px;
          border: 1px solid #BCBCBC;
          display: flex;
          align-items: center;
          padding: 0 15px;
          justify-content: space-between;

          input {
            border: none;
            outline: none;
            font-size: 16px;
          }

          .login-content-item-input-code {
            cursor: pointer;
            user-select: none;

            span {
              color: #4E5969;
              font-size: 14px;
              transition: color 0.3s;
            }

            &.disabled {
              span {
                color: #C9CDD4;
              }
            }
          }
        }
      }

      .login-content-item-read {
        margin-top: 33px;
      }

      .login-content-item-button {
        margin-top: 16px;
        width: 100%;
        height: 46px;
        background: #F45A27;
        border-radius: 3px 3px 3px 3px;
        color: #ffffff;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        line-height: 46px;
        cursor: pointer;
      }
    }

    .login-content-item-button-box {
      width: 100%;
      height: 49px;
      line-height: 49px;
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #8F8F90;
    }
  }
}

.header-nav {
  background-color: #ffffff;
  width: 100%;
  height: 80px;
  border-bottom: 1px solid #e4e7ed;
  position: fixed;
  top: 0;
  z-index: 10;
  box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.1);

  .header-nav-center {
    width: 1404px;
    margin: 0 auto;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-nav-left {
      width: 188px;
      height: 50px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .header-nav-center-tabs {
      padding-left: 50px;
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;

      .header-nav-center-tabs-item {
        font-size: 18px;
        cursor: pointer;
        padding: 0 22px;
        height: 44px;
        text-align: center;
        line-height: 44px;

        &.active {
          color: #000000;
          font-weight: 600;
        }

        &:hover {
          color: #000000;
          font-weight: 600;
        }
      }
    }

    .header-nav-right {
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // background: url(../assets/home/tel.png) no-repeat left center;
      // background-size: 16px 16px;
      padding-left: 20px;

      .phone-number {
        font-size: 16px;
        color: #000000;
        font-size: 14px;
        font-weight: 500;
        margin-right: 30px;
      }

      .header-nav-right-login {
        cursor: pointer;
        text-align: center;
        border-radius: 22px;
        background: #000000;
        width: 94px;
        font-size: 14px;
        height: 44px;
        color: #ffffff;
        font-weight: 600;
        line-height: 44px;
      }

      .header-info {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .header-info-name {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #000000;
        }

        .header-info-img {
          cursor: pointer;
          margin-left: 20px;
          width: 45px;
          height: 45px;
          border-radius: 50%;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}

.nav-tabs {
  flex: 1;
  max-width: 1000px;
}

.user-menu {
  margin-left: 20px;
  margin-right: 20px;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.user-name {
  margin: 0 10px;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .tab-navigation {
    padding: 5px;
  }

  .user-name {
    display: none;
  }
}

// 隐藏发起群聊和发起单聊按钮
:deep(.tui-conversation-header) {
  .tui-conversation-header-left {
    display: none !important;
  }
}

// 隐藏会话列表中的创建按钮
:deep(.tui-conversation-list) {
  .tui-conversation-create {
    display: none !important;
  }
}
</style>